<template>
    <div id="catalog">
        <headers :title='titles'></headers>
        <div class="content"
             v-if="loading">
            <noResouse v-if="Object.keys(resouse).length==0"></noResouse>
            <div class="list-wrap">
                <div class="list-title"
                     v-if="chapter&&chapter.title">《 {{chapter.title}} 》</div>
                <div class='list-con-bg'>
                    <div :class="['list-con',{'text_center':chapter.type}]"
                         v-if="chapter&&chapter.content">
                        <!-- <div v-html="chapter.content"></div> -->
                        <p style="text-indent:2em"
                           v-for="text in content"
                           v-html="text"
                           v-if="chapter.type==0"></p>
                        <p v-for="text in content"
                           v-html="text"
                           v-if="chapter.type==1"></p>
                    </div>
                </div>
                <div class="list-box"
                     v-if="this.lists.length">
                    <!-- 检查作业预览取消一类字二类字区分 zd 2018.11.12 -->
                    <div class="list">
                        <div class="list-word"
                             v-for="(word,index) in lists">{{word.content}}</div>
                    </div>
                    <!-- <div class="list" v-if="word1.length">
            <div class="list-tit">一类字（{{word1.length}}）</div>
            <div class="list-word" v-for="(word,index) in word1">{{word.content}}</div>
          </div>
          <div class="list" v-if="word2.length">
            <div class="list-tit">二类字（{{word2.length}}）</div>
            <div class="list-word" v-for="(word,index) in word2">{{word.content}}</div>
          </div> -->
                </div>
                <div class="list-video"
                     v-if="this.video_aid"
                     @click="clickPreviwe(4,video_aid)">
                    <i class='list-video_img'></i>
                </div>
                <div class="list-text"
                     v-if="this.text_aid"
                     @click="clickPreviwe(5,text_aid)">
                    <i class='list-text_img'></i>
                    <p class='list-text_p'>
                        <span>课文梳理</span>
                        <span>字词、句子、段落梳理</span>
                    </p>
                </div>
            </div>
        </div>
        <template v-else>
            <loadingS></loadingS>
        </template>
         <videoPlayer v-if="!inApp"
                             ref="videoPlayer"
                             @closePlayer="closePlayer"
                             v-show="playFlag"
                             :video_url="videoUrl"
                             submit="1"></videoPlayer>
    </div>
</template>
<script type="text/ecmascript-6">
import headers from 'COMPONENTS/base/header.vue';
import noResouse from 'COMPONENTS/noResouse.vue'
import loadingS from 'COMPONENTS/base/tealoading.vue';
import videoPlayer from 'SRC/components/base/videoPlayer.vue';  // 视频播放弹窗
export default {
    data () {
        return {
           
            titles: "作业预览",
            loading: false,
            taskId: this.$route.params.taskid,
            taskType: this.$route.query.taskType,
            resouse: null,
            lists: [],
            word1: [],//一类字
            word2: [],//二类字
            chapter: {},
            content: [],//文章
            text_aid: null,
            video_aid: null,
            isPreviwe: true,
        }
    },
    created () {
        let that = this;
        this.$http.post(API_URL_TASK_API + '/chinese/check/preview/task/preview', {
            "message_id": this.taskId,
        }).then(res => {
            this.loading = true;
            if (res.data.response == 'ok') {
                this.resouse = res.data.data;
                this.chapter = res.data.data.chapter;
                this.lists = res.data.data.word_list;
                this.text_aid = res.data.data.text_aid;
                this.video_aid = res.data.data.video_aid;
                if (this.chapter) {
                    let _content = this.chapter.content;
                    if (_content.indexOf('<br>') >= 0) {
                        this.content = _content.split('<br>');
                    } else if (_content.indexOf('<br />') >= 0) {
                        this.content = _content.split('<br />');
                    } else if (_content.indexOf('<br \>') >= 0) {
                        this.content = _content.split('<br \>');
                    } else {
                        this.content[0] = _content;
                    }
                }

                if (this.lists.length) {
                    let hash = {};
                    this.lists = this.lists.reduce(function (item, next) {
                        hash[next.content] ? '' : hash[next.content] = true && item.push(next);
                        return item
                    }, [])
                    this.lists.forEach(function (item) {
                        item.color = true;
                        if (item.level == 0) {
                            that.word1.push(item)
                        } else {
                            that.word2.push(item)
                        }
                    });
                }
            }
        })
    },
    filters: {
        tit: function (title) {
            title = title.replace(" ", "|").split("|")[1];
            return "《 " + title + " 》"
        },
    },
    methods: {
         /**退出视频 */
        closePlayer () {
            this.playFlag = false;
        },
        back () {
            this.$router.go(-1)
        },
        clickPreviwe (_type = 4, id) {
            console.log(this.inApp)
            if (_type == 5) {
                this.$router.push(`/chinese/before/combing?id=${id}&teaFlag=1`);
                return false;
            }
            if (this.videoUrl) {
                if (this.inApp) {
                    this.appFunction("ys_video", `${this.videoUrl}`)
                } else {
                    this.playFlag = true;
                    this.$nextTick(() => {
                        this.$refs.videoPlayer.play();
                    })
                    return
                }
                
            } else {
                if (!this.isPreviwe) return false;
                this.isPreviwe = false;
                this.$http.post(API_URL_QNYD_API + '/inner_reading/article/get_article_detail_by_aid', {
                    'aid': id
                }).then(res => {
                    this.isPreviwe = true;
                    let _r = res.data;
                    if (_r.response == 'ok') {
                        if (_type == 4) {
                            this.videoUrl = _r.data.video;
                            if (this.inApp) {
                                this.appFunction("ys_video", `${_r.data.video}`)
                            } else {
                            this.playFlag = true;
                            this.$nextTick(() => {
                                this.$refs.videoPlayer.play();
                            })
                            return
                        }
                        }
                    }
                })
            }
        },
    },
    components: {
        headers,
        noResouse,
        loadingS,
        videoPlayer
    }
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
@import "./src/assets/scss/common/_mixin";

#catalog {
    min-height: 100vh;
    background: #f5f9ff;
    .content {
        .list-wrap {
            background-color: #f5f9ff;
            margin-bottom: 60px / $ppr;
            .list-title {
                font-size: 30px / $ppr;
                text-align: center;
                color: #333;
                height: 40px / $ppr;
                padding: 32px / $ppr 0 24px / $ppr;
                font-weight: bold;
                background: #fff;
            }
            .list-con-bg {
                background: #fff;
                padding: 24px / $ppr;
                .list-con {
                    overflow: hidden;
                    background: #f4f4f4;
                    border-radius: 6px;
                    font-size: 30px / $ppr;
                    line-height: 50px / $ppr;
                    padding: 24px / $ppr;
                    word-break: break-all;
                    word-wrap: break-word;
                    p {
                        color: #333;
                    }
                }
            }

            .list-box {
                border-top: 1px / $ppr solid #e8e8e8;
            }
            .list {
                background-color: #fff;
                height: auto;
                div {
                    border-bottom: 1px / $ppr solid #e8e8e8;
                    height: 96px / $ppr;
                    line-height: 96px / $ppr;
                    padding-left: 24px / $ppr;
                    text-align: left;
                    font-size: 30px / $ppr;
                    color: #333;
                }
                .list-tit {
                    font-weight: bold;
                }
                .list-word {
                    color: #555;
                    &:last-of-type {
                        border: none;
                    }
                }
            }
        }
    }
}
.list-video {
    padding: 24px / $ppr;
    margin-top: 24px / $ppr;
    background: #fff;
    .list-video_img {
        width: 672px / $ppr;
        height: 352px / $ppr;
        display: inline-block;
        background: url("./img/icon_img_04.png") no-repeat;
        background-size: 100% 100%;
    }
}
.list-text {
    padding: 24px / $ppr;
    background: #fff;
    margin-top: 24px / $ppr;
    .list-text_img {
        width: 80px / $ppr;
        height: 80px / $ppr;
        display: inline-block;
        background: url("./img/icon_img_05.png") no-repeat;
        background-size: 100% 100%;
        position: relative;
        top: 8px / $ppr;
    }
    .list-text_p {
        margin-left: 24px / $ppr;
        display: inline-block;
        span {
            display: block;
            &:nth-of-type(1) {
                font-size: 30px / $ppr;
                color: #333;
            }
            &:nth-of-type(2) {
                font-size: 24px / $ppr;
                color: #999999;
            }
        }
    }
}
.text_center {
    text-align: center;
}
</style>
